<script>
   // export let unmatchedUsers=[];
    export let userType;
    import DataTable from '../../../components/data-table.svelte';
    import NoDataInfo from "../../components/nodatainfo.svelte";
    import { onMount } from "svelte";
    export let errors;

    let invalidNames=errors.invalidNames;
    let missingDob=errors.missingDOB;
    let missingUPN=errors.missingUPN;
    let fileErrors=errors.fileErrors;

    const getErrorsList = ()=>{    
        invalidNames=errors.invalidNames;
        missingDob=errors.missingDOB;
        missingUPN=errors.missingUPN;
        fileErrors=errors.fileErrors;
        
    }

    let DOBcolumnDefs =  [{ type: 'date-euro', targets: [1] }];

    let total = 0;
    onMount(()=>{
        getErrorsList();
        total =userType == 'Pupil'?(invalidNames.length+missingDob.length+missingUPN.length+fileErrors.length): userType == "Staff" ?(invalidNames.length+missingDob.length+fileErrors.length):0;
    });

    // const getTableConfig = (dataSource)=>{     
    //         return  {data:dataSource,config: {"paging": false,"info": false,"searching": false, "order": [[0, "asc"]]}};        
    //     }
</script>
<style>
    .card-title{
        background-color: #136f63; 
        color: white; 
        padding:0.5rem 0.5rem 0 0.5rem;
        margin-bottom:0px;
    }
    /* .card-title .material-icons.md1::before { 
        content: "keyboard_arrow_up"; 
    } */
    /* .card-title.collapsed .material-icons.md1::before { 
        content: "keyboard_arrow_down"; 
    }    */
</style>

{#if total == 0}
<NoDataInfo><p>There were no errors found.</p></NoDataInfo>
{/if}
{#if invalidNames.length >0}
<div class="card">
    <a class="card-title d-block" data-toggle="collapse" href="#type1" aria-expanded="true" aria-controls="type1">
        <h5 style="float: left;">Invalid Names </h5>
        <i style="float: right; font-weight: bold !important;" class="material-icons md1"></i>
    </a>
    
    <div id="type1" class="collapse card-body show">
        <DataTable DataLength={invalidNames.length}>
            <thead>
                <tr>
                    <th scope="col" class="sorting_asc" aria-sort="ascending">Name</th>
                    <th>Reason</th>
                </tr>
            </thead>
            <tbody>
                {#each invalidNames as err}
                <tr>                      
                <td>{err.name || ''}</td>                    
                <td>{err.reason}</td>
                </tr>
                {/each}
            </tbody>
        </DataTable>
    </div>
</div>
{/if}

{#if missingDob.length > 0}
<br>
<div class="card">
    <a class="card-title d-block" data-toggle="collapse" href="#type2" aria-expanded="true" aria-controls="type2">
        <h5 style="float: left;">Missing DoB </h5>
        <i style="float: right; font-weight: bold !important;" class="material-icons md1"></i>
    </a>
    
    <div id="type2" class="collapse card-body show">
        <DataTable DataLength={missingDob.length} columnDefs={DOBcolumnDefs}>
            <thead>
                <tr>
                    <th scope="col" class="sorting_asc" aria-sort="ascending">Name</th>                                                
                    <th>Date of Birth</th>
                    <th>Reason</th>
                </tr>
            </thead>
            <tbody>
                {#each missingDob as err}
                <tr>
                    <td>{err.name || ''}</td>
                    <td>{err.birth || ''}</td>
                    <td>{err.reason || ''}</td>
                </tr>
                {/each}
            </tbody>
        </DataTable>   
    </div>
</div>
{/if}
{#if userType=="Pupil" && missingUPN.length > 0}
<br>
<div class="card">
    <a class="card-title d-block" data-toggle="collapse" href="#type3" aria-expanded="true" aria-controls="type3">
        <h5 style="float: left;">Missing UPN </h5>
        <i style="float: right; font-weight: bold !important;" class="material-icons md1"></i>
    </a>
    
    <div id="type3" class="collapse card-body show">
        <DataTable DataLength={missingUPN.length}>
            <thead>
                <tr>
                    <th scope="col" class="sorting_asc" aria-sort="ascending">Name</th> 
                </tr>
            </thead>
            <tbody>
                {#each missingUPN as err}
                <tr>                        
                    <td>{err.name || ''}</td>                      
                </tr>
                {/each}
            </tbody>               
        </DataTable>  
    </div>
</div>
{/if}
{#if fileErrors.length > 0}
<br>
<div class="card">
    <a class="card-title d-block" data-toggle="collapse" href="#type4" aria-expanded="true" aria-controls="type4">
        <h5 style="float: left;">Other Errors </h5>
        <i style="float: right; font-weight: bold !important;" class="material-icons md1"></i>
    </a>
    
    <div id="type4" class="collapse card-body show">
        <DataTable DataLength={fileErrors.length}>
            <thead>
                <tr>
                    <th>Reason</th>
                </tr>
            </thead>
            <tbody>
                {#each fileErrors as err}
                <tr> 
                    <td>{err.reason?err.reason.split(":")[1] : ''}</td>
                </tr>
                {/each}
            </tbody>
        </DataTable>   
    </div>
</div>
{/if}

